export default "__VITE_PUBLIC_ASSET__caa440be__"